// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { VDateInput } from 'vuetify/labs/VDateInput'
import { es } from "vuetify/locale";
 import * as components from 'vuetify/components'
 import * as directives from 'vuetify/directives'
 
// Vuetify
import { createVuetify } from 'vuetify'
import { VCalendar } from 'vuetify/lib/labs/VCalendar/index.mjs';


//import { Vue3Html2pdf } from 'vue3-html2pdf';



export default createVuetify({
   locale: {
    locale: "es",
    fallback: "es",
    messages: {
      es,
    },
  },
   components:{ 
    //Vue3Html2pdf,
    VDateInput,
    VCalendar,
  },
   directives,  
   icons: {
    defaultSet: 'mdi', // This is already the default value - only for display purposes
    },
  // https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
}
)
